import { Space } from '@tribeplatform/gql-client/types'
import { EventForm } from '@tribeplatform/react-components'
import { getPostIdFromPath } from '@tribeplatform/react-components/common/utils'
import { useI18n } from '@tribeplatform/react-components/i18n'
import { useEvent } from '@tribeplatform/react-sdk/hooks'
import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

interface Props {
  eventPath: string
  selectedSpace?: Space
  onCancel: () => void
}

export const EventComposer = ({
  eventPath,
  onCancel,
  selectedSpace,
}: Props) => {
  const { $t } = useI18n()
  const eventId = eventPath ? getPostIdFromPath(eventPath) : null
  const { data: event, isInitialLoading: isLoading } = useEvent({
    variables: { id: eventId },
    useQueryOptions: { enabled: !!eventId },
  })

  if (isLoading) {
    return null
  }

  return (
    <Card>
      <Card.Header
        title={
          <div className="flex space-s-3 items-center">
            <IconButton
              variant="tertiaryNeutral"
              rounded
              size="lg"
              icon={<SvgIcon className="rtl:-scale-x-100" name="arrow-left" />}
              onClick={onCancel}
              aria-label={$t({
                id: 'Generics.Back',
                defaultMessage: 'Back',
              })}
            />
            <span className="text-xl font-medium flex-1">
              {!event
                ? $t({
                    id: 'Composer.EventFormDialog.Create.HeaderTitle',
                    defaultMessage: 'Create a new event',
                  })
                : $t({
                    id: 'Composer.EventFormDialog.Update.HeaderTitle',
                    defaultMessage: 'Update event',
                  })}
            </span>
          </div>
        }
      />
      <Card.Content>
        <EventForm
          event={event}
          selectedSpace={selectedSpace}
          onCancel={onCancel}
        />
      </Card.Content>
    </Card>
  )
}
